import { useMemo } from "react";

/** 고정 채널 + 서버 연동(Y) 채널 병합 후 10개씩 페이징된 채널 리스트 */
const BASE_CHANNELS = [
    "baemin", "baemin1", "baeminstore", "yogiyo", "yogiyoexpress", "eats",
    "wmpo", "mukkebi", "ddangyo", "ddangbaedal", "naver",
    "specialdelivery", "daeguro", "incheoneum", "baedalys",
    "panda", "pandaself"
];

const CHUNK_SIZE = 10;

/**
 * @param {Object} rawShopApiSetting - 설정 스토어의 getShopApiSetting (또는 {} )
 * @returns {{ dynamicChannelList: Object, pageNo: number }}
 */
export function useDynamicChannelList(rawShopApiSetting = {}) {
    return useMemo(() => {
        const shopApiSetting = JSON.parse(JSON.stringify(rawShopApiSetting || {}));

        // 1. 베이스 채널로 시작 (etc는 맨 뒤에 넣기 위해 제외)
        const combinedChannels = [...BASE_CHANNELS];

        // 2. 서버 연동 값(Y) 확인하여 동적으로 리스트에 추가 (중복 방지)
        Object.entries(shopApiSetting).forEach(([key, value]) => {
            if (key.endsWith("Yn") && value === "Y") {
                let channelKey = key.replace("Yn", "").toLowerCase();
                if (channelKey === "hungrypanda") {
                    channelKey = "panda";
                }
                if (!combinedChannels.includes(channelKey)) {
                    combinedChannels.push(channelKey);
                }
            }
        });

        // 3. '기타(etc)' 채널은 무조건 맨 마지막에 추가
        if (!combinedChannels.includes("etc")) {
            combinedChannels.push("etc");
        }

        // 4. 10개씩 페이징 데이터 쪼개기
        const totalPages = Math.ceil(combinedChannels.length / CHUNK_SIZE) || 1;
        const dynamicChannelList = {};

        for (let i = 0; i < totalPages; i++) {
            const chunk = combinedChannels.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
            while (chunk.length < CHUNK_SIZE) {
                chunk.push("");
            }
            dynamicChannelList[i] = chunk;
        }

        return {
            dynamicChannelList,
            pageNo: totalPages
        };
    }, [rawShopApiSetting]);
}

export default useDynamicChannelList;
